<template>
  <div
    @click="compressed = !compressed"
    :class="[
      'reaction-selector',
      compressed ? 'reaction-selector-compressed' : '',
      align === 'right' ? 'reaction-selector-right' : ''
    ]"
  >
    <span style="display: flex" v-if="compressed">
      <ReactionIconTotal
        v-for="r in reactions"
        :key="'reaction-summary-' + r.token"
        :icon="r.iconName"
        :value="reactionsCount(r)"
      />
    </span>
    <div
      v-if="compressed"
      style="color: white; padding-left: 4px; padding-right: 4px"
    >
      {{ userReactions.length }}
    </div>
    <div v-if="!compressed">
      <div
        class="react-text-container"
        v-for="userReaction in userReactions"
        :key="'reaction-' + messageId + userReaction.identity"
      >
        <span
          :class="
            'reaction-icon material-icons reaction-icon-' +
              icon(userReaction.reaction)
          "
        >
          {{ icon(userReaction.reaction) }}
        </span>
        <span class="react-text">{{ userReaction.friendlyName }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { REACTIONS } from "@/helpers/chat";
import ReactionIconTotal from "./ReactionIconTotal";

export default Vue.extend({
  name: "ReactionSelector",
  props: {
    userReactions: { type: Array },
    userReactionsSummary: { type: Object },
    messageId: { type: String },
    align: { type: String }
  },
  components: { ReactionIconTotal },
  data() {
    return {
      reactions: REACTIONS.toList(),
      compressed: true
    };
  },
  methods: {
    handleClick(reaction) {
      this.$emit("react", reaction);
    },
    icon(reactionToken) {
      const iconName = REACTIONS.iconName(reactionToken);
      return iconName;
    }
  },
  computed: {
    reactionsCount() {
      return reaction => this.userReactionsSummary[reaction.token];
    }
  }
});
</script>
<style scoped>
.reaction-selector {
  display: flex;
  flex: 1;
  background-color: transparent;
  justify-content: flex-start;
  align-items: center;
  padding-top: 5px;
  padding-bottom: 5px;
}

.reaction-selector-right {
  justify-content: flex-end;
}

.reaction-selector-compressed {
  padding-bottom: 0;
  cursor: pointer !important;
}

.react-text-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 3px 0;
}
.react-text {
  font-size: 12px;
  color: white;
  margin-left: 5px;
}
.reaction-icon {
  font-size: 14px;
  padding-left: 3px;
  color: white;
}

.reaction-icon-priority_high,
.reaction-icon-question_mark {
  text-shadow: 1px 0 0 white;
}
</style>
